module.exports = __webpack_public_path__ + "app/assets/images/woman20-0963ff813193c65c2e18707ad9f18dc8.jpg";